<ng-container *transloco="let t;">
    <div class="contract-control-step-two">
        <h2 class="step-heading-title">{{t('Input label text (contractControl stepForm) - Cost')}}</h2>
        
        <div class="costPreviewCard-wrapper table-responsive mt-1">
            <table class="table table-hover table-striped">
                <thead>
                    <tr>
                        <th class="col-width">{{ t('Contract control box field title (Contract control section) - Description') }}</th>
                        <th>{{ t('Contract control box field title (Contract control section) - Billing start date') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for(control of costControls.controls; track control; let i = $index) {
                         <tr>
                            <td class="col-width" (click)="openCostFormModal(control.value, i)">
                                <span class="cost_description">{{ control.get('description')?.value ?? '' }}</span>
                                <div>
                                    <span class="cost_amount">{{ control.get('cost_amount')?.value | numberFormatPipe }} {{ control.get('cost_currency')?.value }} </span> / <span class="cost_billing_frequency" placement="auto" triggers="hover" ngbTooltip="Billing frequency">{{ control.get('billing_frequency')?.value }}</span>
                                </div>
                            </td>
                            <td (click)="openCostFormModal(control.value, i)"><span class="hover-effect">{{ control.get('billing_start')?.value | dateFormat | async }}</span></td>
                            <td class="text-end" (click)="removeCost(i)">
                                <i data-feather="trash-2" class="cursor-pointer text-danger"></i>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
            
            <button type="button" class="btn btn-primary btn-sm mt-1" 
                (click)="openCostFormModal()">
                <i data-feather="plus" class="me-25"></i>
                {{t('Add cost button text - (Contract control cost card) - Add cost')}}
            </button>
        </div>
    </div>
</ng-container>
